<template>
  <main v-if="isVisible" class="modal-wrapper relative z-50 modal-filter fixed inset-0 w-full h-screen flex mt-2 justify-center bg-semi-75 h-fit">
    <transition name="modal-fade">
      <div class="modal-overlay" @click="$emit('close-modal')">
        <div class="modal absolute h-screen" @click.stop>
          <!-- <h6>Saved!</h6> -->
          <div @click="$emit('Cancel')" class="absolute right-0 pr-4 top-5 cursor-pointer" v-if="crossVisible">
            <x-icon size="1.5x"></x-icon>
          </div>
          <div class="bg-white">
            <div class="text-gray-500 px-4">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </main>
</template>

<script>
import { XIcon } from 'vue-feather-icons';
// eslint-disable-next-line

export default {
  components: { XIcon },
  name: 'Generic',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
      required: true,
    },
    crossVisible: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup() {
    console.log('modal opened');
  },
};
</script>
<style lang="postcss">
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #000000da;
}
.modal {
  text-align: center;
  background-color: white;
  height: fit-content;
  //max-width: 500px;
  margin-top: 20vh;
  padding: 40px 0;
}
p {
  /* font-weight: 500; */
  font-size: 16px;
  margin: 20px 0;
}
/* button {
  background-color: #ac003e;
  width: 150px;
  height: 40px;
  color: white;
  font-size: 14px;
  border-radius: 16px;
  margin-top: 50px;
} */
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>
